export default "__VITE_ASSET__CV2_z68y__"